import { useNavigate } from "react-router-dom";
import PathologyResultsBreakout from "../../components/PathologyResultsBreakout";
import { Stack } from "@mui/material";
import { trackPageViewV2 } from "@/services/analytics-adapter";
import { useEffect } from "react";

export default function PathologyResultsBreakoutPage() {
  const navigate = useNavigate();

  function onBackButtonClick() {
    navigate(-1);
  }

  useEffect(() => {
    trackPageViewV2({
      pageName: "Pathology:PathologyResultsBreakout",
      pageSubSection1: "Pathology",
      pageSubSection2: "Pathology:PathologyResultsBreakout",
      pageCategory: "Pathology",
    });
  }, []);

  return (
    <Stack height="100vh" p={2}>
      <PathologyResultsBreakout onBackButtonClick={onBackButtonClick} />
    </Stack>
  );
}
